import axios from 'axios'

const fetchProducts = async (categories = [], page = 1, pageSize = 12) => {
    return new Promise(async (resolve, reject) => {
        axios.post('/api/products', {
            CategoryIds: categories,
            page,
            pageSize,
            Include: ["webCategories", "Media"],
            Filter: ["Orderable", "InStock", "Finished", "BestSeller"]
        }, {
            headers: {
                'Content-Type': 'application/json',
                // 'Accept': 'application/json',
            }
        })
            .then(response => {
                const productData = response.data;
                resolve(productData)
            })
            .catch(error => {
                reject(error)
            });
    })
};

export default fetchProducts